export default __webpack_public_path__ + "static/media/15.74e83361.png";